import { tsUtils } from '@neo-one/ts-utils';
import { Helper } from '../Helper';
import { createWrapParam } from './utils';
export class HandleSendUnsafeReceiveHelperBase extends Helper {
    constructor({ method, returnType, opposite }) {
        super();
        this.method = method;
        this.returnType = returnType;
        this.opposite = opposite;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitSysCall(node, 'System.ExecutionEngine.GetScriptContainer');
        sb.emitSysCall(node, 'Neo.Transaction.GetHash');
        sb.emitHelper(node, options, sb.helpers.isProcessedTransaction);
        if (!this.opposite) {
            sb.emitSysCall(node, 'System.ExecutionEngine.GetScriptContainer');
            sb.emitSysCall(node, 'Neo.Transaction.GetOutputs');
            sb.emitHelper(node, options, sb.helpers.getOutputAssetValueMap);
            sb.emitSysCall(node, 'System.ExecutionEngine.GetScriptContainer');
            sb.emitSysCall(node, 'Neo.Transaction.GetReferences');
            sb.emitHelper(node, options, sb.helpers.mergeAssetValueMaps({ add: false }));
            sb.emitHelper(node, optionsIn, sb.helpers.mapEvery({
                each: () => {
                    sb.emitOp(node, 'DROP');
                    sb.emitPushInt(node, 0);
                    sb.emitOp(node, this.lessThan ? 'LT' : 'GT');
                },
            }));
            sb.emitOp(node, 'NOT');
            sb.emitOp(node, 'BOOLOR');
        }
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
            },
            whenTrue: () => {
                sb.emitPushBoolean(node, false);
            },
            whenFalse: () => {
                sb.emitPushInt(node, 1);
                sb.emitHelper(node, options, sb.helpers.getArgument);
                sb.withScope(node, options, (innerOptions) => {
                    sb.emitHelper(node, innerOptions, sb.helpers.parameters({
                        params: tsUtils.parametered.getParameters(this.method),
                        mapParam: createWrapParam(sb),
                    }));
                    sb.emitHelper(node, innerOptions, sb.helpers.invokeSmartContractMethod({ method: this.method }));
                    sb.emitHelper(node, innerOptions, sb.helpers.unwrapValRecursive({ type: this.returnType }));
                    sb.emitHelper(node, innerOptions, sb.helpers.setProcessedTransaction);
                });
            },
        }));
    }
}

//# sourceMappingURL=HandleSendUnsafeReceiveHelperBase.js.map
